'use strict';

const MOBILE_NET_MODE = require('../../../../constant').MOBILE_NET_MODE;

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt8("data.mobile_type", value => MOBILE_NET_MODE[value]);
    reader.readString(16, "data.mobile_number");
    reader.readString(8, "data.mobile_pin_code");
    reader.readUInt32LE("data.periodic");
    reader.readUInt32LE(); //多传了一个"data.interval"
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/digit/params-report-parser.js